import { defineComponent as _defineComponent } from 'vue'
import { computed, withDefaults } from 'vue';

import { Field, Product } from '@/shared/api/rest/models';
import { Data } from '@/shared/mixins/store/types';

import SidebarFilterBadgesContainer from './SidebarFilterBadgesContainer.vue';

interface Props {
  fields: Field[];
  cropsById: Data<Product>;
  activeFilters: string[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CropFilters',
  props: {
    fields: { default: () => [] },
    cropsById: { default: () => ({}) },
    activeFilters: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { fields: Field[], cropsById: Data<Product>, activeFilters: string[] }



const cropsData = computed<string[]>(() => {
  const data: Data<{ id: string; name: string; area: number }> = {};
  props.fields.forEach((field: Field) => {
    let { cropId } = field;
    const { fieldSize } = field;
    if (cropId == null) {
      cropId = 'no-crop';
    } else if (props.cropsById[cropId] == null || fieldSize <= 0) {
      return;
    }
    if (data[cropId] == null) {
      data[cropId] = {
        id: cropId,
        name: cropId === 'no-crop' ? '' : props.cropsById[cropId].name,
        area: 0,
      };
    }
    data[cropId].area += fieldSize;
  });
  const cropsDataSorted = Object.values(data).sort((a, b) => b.area - a.area);
  return cropsDataSorted.map((crop) => crop.name);
});
const filteredCrops = computed<string[]>(() => [...new Set(cropsData.value)]);

return { __sfc: true,props, cropsData, filteredCrops, SidebarFilterBadgesContainer }
}

})